export const ConexionProperties = {
    _PROTOCOL: "https://",
    _IP: "urku.aster.pe",
    _PORT: "80",
    _CONTEXT: "urku"
}